import React from 'react';
import {
  Redirect, Route, Switch,
} from 'react-router-dom';
import CardInformation from '../pages/cardInfo';
import CardLicenseAndStatus from '../pages/cardLicenseAndStatus';
import ReassignEID from '../pages/reassigneId';
import UserInfo from '../pages/userInfo';
import AddNewCard from '../pages/addNewCard';
import UserManagement from '../pages/userManagement';
import CustomerAccounts from '../pages/customerAccounts';

function AdminRoute() {
  return (
    <Switch>
      <Route exact key="reassign-eid" path="/reassign-eid" name="ReassigneId" component={ReassignEID} />

      <Route exact key="card-license" path="/card-license" name="CardLicenseAndStatus" component={CardLicenseAndStatus} />
      <Route exact key="card-information" path="/card-information/:id" name="CardInformation" component={CardInformation} />
      <Route exact key="add-new-card" path="/add-new-card" name="AddNewCard" component={AddNewCard} />

      <Route exact path="/user-management" name="HospitalRoomManagement" component={UserManagement} />
      <Route exact key="customer-accounts" path="/customer-accounts" name="CustomerAccounts" component={CustomerAccounts} />
      <Route exact key="user-info" path="/user-info/:id" name="UserInfo" component={UserInfo} />

      <Route exact key="my-profile" path="/my-profile" name="UserInfo" component={UserInfo} />
      <Redirect from="/" to="/reassign-eid" />
    </Switch>
  );
}

export default AdminRoute;
